module.exports = __webpack_public_path__ + "static/bg-1-4d5b416afe8b5abb54088b158e91a07c.jpg";